<template>
  <article class="holiday-page">
    <EventHero :event="event" />
    <EventSectionNav :items="navigation" />
    <EventSummary :event="event" heading="A Night to Celebrate" kicker="Celebration Summary" />
    <EventDetailsCard :details="details" />
    <EntitySection :items="event.venues" :entity-by-id="entityById" section-id="venue" title="The Celebration" />
    <EntitySection :items="event.restaurants" :entity-by-id="entityById" section-id="restaurant" title="Dinner Together" />
    <EntitySection :items="event.hotels" :entity-by-id="entityById" section-id="hotel" title="Where We Stayed" />
    <CrewSection :crew="event.crew" />
    <EventGallery :media="event.gallery" :title="`${event.title} Moments`" />
  </article>
</template>

<script>
import EventHero from '../event/EventHero.vue';
import EventSectionNav from '../event/EventSectionNav.vue';
import EventSummary from '../event/EventSummary.vue';
import EventDetailsCard from '../event/EventDetailsCard.vue';
import EntitySection from '../entities/EntitySection.vue';
import CrewSection from '../people/CrewSection.vue';
import EventGallery from '../media/EventGallery.vue';

export default {
  name: 'HolidayPartyEventPage',
  components: {
    EventHero, EventSectionNav, EventSummary, EventDetailsCard, EntitySection, CrewSection, EventGallery,
  },
  props: { event: { type: Object, required: true }, entityById: { type: Object, required: true } },
  computed: {
    details() { return { date: this.event.startDate, location: [this.event.city, this.event.region].filter(Boolean).join(', '), ...(this.event.holidayParty || {}) }; },
    navigation() { return [{ id: 'overview', label: 'Summary' }, { id: 'restaurant', label: 'Restaurant', show: this.event.restaurants?.length }, { id: 'hotel', label: 'Hotel', show: this.event.hotels?.length }, { id: 'crew', label: 'Crew', show: this.event.crew?.length }, { id: 'gallery', label: 'Gallery', show: this.event.gallery?.length }].filter((item) => item.show !== false); },
  },
};
</script>

<style scoped>.holiday-page { background: #050505; }</style>
